import { render, staticRenderFns } from "./ChannelSales.vue?vue&type=template&id=3e107fdf&scoped=true"
import script from "./ChannelSales.vue?vue&type=script&lang=js"
export * from "./ChannelSales.vue?vue&type=script&lang=js"
import style0 from "./ChannelSales.vue?vue&type=style&index=0&id=3e107fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e107fdf",
  null
  
)

export default component.exports